import { Box, Button, styled } from '@mui/material';

import { Colors } from '../../Styles/colors';


export const FlexBox = styled(Box)(()=>({
  display: 'flex',
  flexDirection: 'row',
  flexWrap: 'wrap'
}))

export const StyledButton = styled(Button)(({theme})=>({
  width:'50%',
  alignSelf:'center',
  color:`white`,
  backgroundColor:`${Colors.primary.orange}`,
  fontSize:'16px',
  '&:hover': {
    backgroundColor: `${Colors.primary.blue}`,
  },
}));

export const Form = styled('form')`
  padding:20px;
  display:flex;
  flex-direction:column;
  margin:auto;
`;

export const FormItem = styled('div')`
  padding-bottom:20px;
  width:100%
`;

